<section>
    <div class="mainDiv">
        <div class="legancy_content">
            <div class="banner_content_slider_desk">
                <img src="../../../assets/img/new-kidzee/banner/our_presence.png" class="img-fluid desk_res"alt="...">
                <!-- <div id="carouselExampleControls" class="carousel slide">
                    <div class="carousel-inner">
                      <div class="carousel-item active">
                        <img src="../../../assets/img/new-kidzee/banner/pantamine_banner.png" class="d-block img-fluid slider_banner" alt="...">
                      </div>
                      <div class="carousel-item">
                        <img src="../../../assets/img/new-kidzee/banner/pantamine_banner.png" class="d-block img-fluid slider_banner" alt="...">
                      </div>
                      <div class="carousel-item">
                        <img src="../../../assets/img/new-kidzee/banner/pantamine_banner.png" class="d-block img-fluid slider_banner" alt="...">
                      </div>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                      <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                      <span class="carousel-control-next-icon" aria-hidden="true"></span>
                      <span class="visually-hidden">Next</span>
                    </button>
                  </div> -->
                  <h1 class="whiteTitle">{{headerTitle}}</h1>
        <div class="subMenu_content">
            <app-sub-menu></app-sub-menu>
        </div>
            </div>
            <div class="banner_content_slider_mob">
                <h1 class="whiteTitle">{{headerTitle}}</h1>
                <div class="subMenu_content">
                    <app-sub-menu></app-sub-menu>
                </div>
                <img src="../../../assets/img/new-kidzee/banner/our_responsive.png" width="100%" alt="">
                </div>
            <div class="admissionForm">
                <div class="row flex-column-reverse flex-md-row">
                    <div class="col-md-6">
                        <div class="desk_res">
                            <div class="count_box">
                                <div class="count"> 
                                    <div class="num_box">1</div>
                                    <div class="count_para">
                                        Fill the School Admission Inquiry 
                                        Form on the Website
                                    </div>  
                                </div>
                                <div class="count">   
                                    <div class="num_box">2</div>
                                    <div class="count_para">
                                        We will invite you to the nearest Kidzee preschool
                                    </div> 
                                </div>
                                <div class="count"> 
                                    <div class="num_box">3</div>
                                    <div class="count_para">
                                        Visit the School for Campus Tour
                                    </div>   
                                </div>
                                <div class="count">  
                                    <div class="num_box">4</div>
                                    <div class="count_para">
                                        Join the Kidzee Family
                                    </div>  
                                </div>
                            </div>
                        </div>
                        <div class="mob_res">
                            <div class="count_box_mob ">
                                <div id="carouselExampleIndicators" class="carousel slide">
                                    <div class="carousel-indicators">
                                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active"
                                            aria-current="true" aria-label="Slide 1"></button>
                                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"
                                            aria-label="Slide 2"></button>
                                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2"
                                            aria-label="Slide 3"></button>
                                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3"
                                            aria-label="Slide 4"></button>
                                    </div>
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <div class="count"> 
                                                <div class="num_box">1</div>
                                                <div class="count_para">
                                                    Fill the School Admission Inquiry 
                                                    Form on the Website
                                                </div>  
                                            </div>
                                        </div>
                                        <div class="carousel-item">
                                            <div class="count">   
                                                <div class="num_box">2</div>
                                                <div class="count_para">
                                                    We will invite you to the nearest Kidzee preschool
                                                </div> 
                                            </div>
                                        </div>
                                        <div class="carousel-item">
                                            <div class="count"> 
                                                <div class="num_box">3</div>
                                                <div class="count_para">
                                                    Visit the School for Campus Tour
                                                </div>   
                                            </div>
                                        </div>
                                        <div class="carousel-item">
                                        <div class="count">  
                                            <div class="num_box">4</div>
                                            <div class="count_para">
                                                Join the Kidzee Family
                                            </div>  
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <app-partneradmission></app-partneradmission>
                    </div>
                </div>
            </div>
        </div>

        <div class="cities_list_content mt-5">
            <img src="../../../assets/img/new-kidzee/chocolate_img.png" class="chocolate_img" alt="">
            <img src="../../../assets/img/new-kidzee/scale.png" class="scal_img" alt="">
            <div class="text_content_right cities_title">
                Cities where our Presence is
                <br><img src="../../../assets/img/new-kidzee/bottom_img.png" class="bottom_img" alt="">
            </div>

            <ul class="alphabet mt-3" id="deskTopView">
                <li><a class="menu active" (click)="getcenter('A')"> A</a></li>
                <li><a class="menu" (click)="getcenter('B')">B</a></li>
                <li><a class="menu" (click)="getcenter('C')">C</a></li>
                <li><a class="menu" (click)="getcenter('D')">D</a></li>
                <li><a class="menu" (click)="getcenter('E')">E</a></li>
                <li><a class="menu" (click)="getcenter('F')">F</a></li>
                <li><a class="menu" (click)="getcenter('G')">G</a></li>
                <li><a class="menu" (click)="getcenter('H')">H</a></li>
                <li><a class="menu" (click)="getcenter('I')">I</a></li>
                <li><a class="menu" (click)="getcenter('J')">J</a></li>
                <li><a class="menu" (click)="getcenter('K')">K</a></li>
                <li><a class="menu" (click)="getcenter('L')">L</a></li>
                <li><a class="menu" (click)="getcenter('M')">M</a></li>
                <li><a class="menu" (click)="getcenter('N')">N</a></li>
                <li><a class="menu" (click)="getcenter('O')">O</a></li>
                <li><a class="menu" (click)="getcenter('P')">P</a></li>
                <li><a class="menu" (click)="getcenter('Q')">Q</a></li>
                <li><a class="menu" (click)="getcenter('R')">R</a></li>
                <li><a class="menu" (click)="getcenter('S')">S</a></li>
                <li><a class="menu" (click)="getcenter('T')">T</a></li>
                <li><a class="menu" (click)="getcenter('U')">U</a></li>
                <li><a class="menu" (click)="getcenter('V')">V</a></li>
                <li><a class="menu" (click)="getcenter('W')">W</a></li>
                <li><a class="menu" (click)="getcenter('X')">X</a></li>
                <li><a class="menu" (click)="getcenter('Y')">Y</a></li>
                <li><a class="menu" (click)="getcenter('Z')">Z</a></li>
            </ul>

            <div class="tab_box">
                <div class="row mt-5">
                    <div *ngIf="cityList.length==0">
                        No Record Found!
                    </div>
                    <div class="col-md-2">
                        <div class="cities_list text-center">
                            <ul>
                                <li *ngFor="let city of cityList.slice(0,5)">
                                    <p (click)="goTocity(city.city)">{{city.city}}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="cities_list text-left">
                            <ul>
                                <li *ngFor="let city of cityList.slice(5,10)">
                                    <p (click)="goTocity(city.city)">{{city.city}}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="cities_list text-left">
                            <ul>
                                <li *ngFor="let city of cityList.slice(10,15)">
                                    <p (click)="goTocity(city.city)">{{city.city}}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="cities_list text-left">
                            <ul>
                                <li *ngFor="let city of cityList.slice(15,20)">
                                    <p (click)="goTocity(city.city)">{{city.city}}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="cities_list text-left">
                            <ul>
                                <li *ngFor="let city of cityList.slice(20,25)">
                                    <p (click)="goTocity(city.city)">{{city.city}}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="cities_list text-left">
                            <ul>
                                <li *ngFor="let city of cityList.slice(25,30)">
                                    <p (click)="goTocity(city.city)">{{city.city}}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div *ngIf="cityList.length>29" class="d-flex justify-content-end align-items-center">
                        <button class="btn more_btn" routerLink="/locateUs">More</button>
                    </div>
                </div>

                <div id="mobileView">
                    <ul class="alphabet">
                        <li><a class="menu active" (click)="getcenter('A')"> A</a></li>
                        <li><a class="menu" (click)="getcenter('B')">B</a></li>
                        <li><a class="menu" (click)="getcenter('C')">C</a></li>
                        <li><a class="menu" (click)="getcenter('D')">D</a></li>
                        <li><a class="menu" (click)="getcenter('E')">E</a></li>
                        <li><a class="menu" (click)="getcenter('F')">F</a></li>
                        <li><a class="menu" (click)="getcenter('G')">G</a></li>
                        <li><a class="menu" (click)="getcenter('H')">H</a></li>
                        <li><a class="menu" (click)="getcenter('I')">I</a></li>
                        <li><a class="menu" (click)="getcenter('J')">J</a></li>
                        <li><a class="menu" (click)="getcenter('K')">K</a></li>
                        <li><a class="menu" (click)="getcenter('L')">L</a></li>
                        <li><a class="menu" (click)="getcenter('M')">M</a></li>
                        <li><a class="menu" (click)="getcenter('N')">N</a></li>
                        <li><a class="menu" (click)="getcenter('O')">O</a></li>
                        <li><a class="menu" (click)="getcenter('P')">P</a></li>
                        <li><a class="menu" (click)="getcenter('Q')">Q</a></li>
                        <li><a class="menu" (click)="getcenter('R')">R</a></li>
                        <li><a class="menu" (click)="getcenter('S')">S</a></li>
                        <li><a class="menu" (click)="getcenter('T')">T</a></li>
                        <li><a class="menu" (click)="getcenter('U')">U</a></li>
                        <li><a class="menu" (click)="getcenter('V')">V</a></li>
                        <li><a class="menu" (click)="getcenter('W')">W</a></li>
                        <li><a class="menu" (click)="getcenter('X')">X</a></li>
                        <li><a class="menu" (click)="getcenter('Y')">Y</a></li>
                        <li><a class="menu" (click)="getcenter('Z')">Z</a></li>
                    </ul>
                </div>
            </div>
            <img src="../../../assets/img/new-kidzee/bag_img.png" class="bag_img" alt="">
            <img src="../../../assets/img/new-kidzee/shift.png" class="shift_img" alt="">
        </div>

        <div class="blogs_content mt-5">
            <app-blogs></app-blogs>
        </div>
        <div class="testimonial_content mt-5">
            <app-testimonial></app-testimonial>
        </div>
    </div>
</section>